import React from "react";
import { useI18n } from "../i18n/LanguageContext";
import { useRequestModal } from "../context/RequestModalContext";
import { whatsAppSimple } from "../lib/api";
import { Reveal } from "../components/Reveal";

export const FinalCTA = () => {
  const { t } = useI18n();
  const { openRequest } = useRequestModal();
  return (
    <section className="py-32 md:py-48" data-testid="final-cta-section">
      <div className="max-w-5xl mx-auto px-6 md:px-12 text-center">
        <Reveal>
          <h2 className="font-serif font-light leading-[1] text-5xl md:text-7xl lg:text-8xl mb-6">{t("finalCta.title")}</h2>
          <p className="text-vm-text2 font-light text-lg mb-12">{t("finalCta.sub")}</p>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="flex flex-wrap items-center justify-center gap-4">
            <button onClick={() => openRequest("other")} className="vm-btn-primary px-9 py-4 text-xs tracking-[0.2em] uppercase" data-testid="final-request-button">
              {t("common.makeRequest")}
            </button>
            <a href={whatsAppSimple()} target="_blank" rel="noopener noreferrer" className="vm-btn-ghost px-9 py-4 text-xs tracking-[0.2em] uppercase" data-testid="final-whatsapp-button">
              {t("common.whatsapp")}
            </a>
            <a href="tel:+34645459043" className="vm-btn-ghost px-9 py-4 text-xs tracking-[0.2em] uppercase" data-testid="final-call-button">
              {t("common.call")}
            </a>
          </div>
          <p className="vm-label mt-12">{t("finalCta.availability")}</p>
        </Reveal>
      </div>
    </section>
  );
};
